import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form';
import { withRouter } from 'react-router';
import v from 'validate.js';
import styles from './style.module.css';
import * as Routes from '../../../../../constants/routes';
import { onSubmit } from '../../../../../common/components/submit-button';
import RenderSelect from '../../../../../common/components/render-input/select';

export const formName = Routes.STEPFIVE;

const validate = values => v(values, {
    loanTerm: {
        presence: {
            allowEmpty: false,
            message: 'is required'
        }
    }
});

const minValue = 1;
const maxValue = 10;

const loanTermOptions = Array.from(
    new Array((maxValue - minValue) + 1).fill(minValue),
    (value, i) => value + i
)
    .reduce((values, label) => ({
        ...values,
        [label]: label
    }), {});

class StepFiveForm extends Component {
    render() {
        return (
            <form className={styles.form}>
                <Field
                    name='loanTerm'
                    label='Loan Term'
                    prefix='Years'
                    options={loanTermOptions}
                    component={RenderSelect}
                />
            </form>
        );
    }
}

StepFiveForm = reduxForm({
    form: formName,
    destroyOnUnmount: false,
    validate,
    onSubmit,
    initialValues: {
        loanTerm: 5
    },
    redirectPath: `/loan${Routes.SUMMARY}`
})(StepFiveForm);

export default withRouter(StepFiveForm);

